import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const PortabilityPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Portabilidad</PageTitle>
      <View />
    </>
  );
};

export { PortabilityPage };
